import Detail1 from 'images/games/8-ball-strike/detail1.png'
import Detail2 from 'images/games/8-ball-strike/detail2.png'
import Detail3 from 'images/games/8-ball-strike/detail3.png'
import Footer from 'images/games/8-ball-strike/footer.png'
import Icon from 'images/games/8-ball-strike/icon.png'
import Swiper1 from 'images/games/8-ball-strike/swiper1.webp'
import Swiper2 from 'images/games/8-ball-strike/swiper2.webp'
import Swiper3 from 'images/games/8-ball-strike/swiper3.webp'
import Swiper4 from 'images/games/8-ball-strike/swiper4.webp'
import Swiper5 from 'images/games/8-ball-strike/swiper5.webp'
import Swiper6 from 'images/games/8-ball-strike/swiper6.webp'
import Swiper7 from 'images/games/8-ball-strike/swiper7.webp'
import Swiper8 from 'images/games/8-ball-strike/swiper8.webp'
import { BingoClashLink, GamesLink, SolitaireClashLink } from '../../components'
import { EightBallStrikeEntity } from './entity'
import { TemplatePageProps } from './types'

export const EightBallStrikeDetail: TemplatePageProps = {
  entity: {
    ...EightBallStrikeEntity,
    logo: Icon,
    title: 'Dive Into Action with 8 Ball Strike',
    description: (
      <>
        Chalk up and shoot your shot in <strong>8 Ball Strike</strong>—the <strong>free pool game</strong> where your
        cue skills can give you the opportunity to win real cash prizes! Whether you’re a total beginner or a seasoned
        pro, this <strong>8 ball pool game</strong> welcomes all skill levels without a steep learning curve.
        <br />
        <br />
        <strong>Download 8 Ball Strike now</strong> and start your winning streak—fun, friendly, and fiercely
        competitive!
      </>
    ),
  },
  media: {
    facebook: 'https://www.facebook.com/8BallStrike/',
    instagram: 'https://www.instagram.com/8ballstrike/',
  },
  swiper: [
    { image: Swiper1 },
    { image: Swiper2 },
    { image: Swiper3 },
    { image: Swiper4 },
    { image: Swiper5 },
    { image: Swiper6 },
    { image: Swiper7 },
    { image: Swiper8 },
  ],
  content: [
    {
      title: 'How to Play 8 Ball and Rack Up Big Points',
      description: (
        <>
          Curious about <strong>how to play 8 ball</strong> in <strong>8 Ball Strike</strong>? Here&#39;s how it works:
          you start each round with <strong>three cue balls</strong> and a <strong>fixed time limit</strong>. Line up
          your shot, pull back to adjust power, and aim to pocket all solids and stripes.
          <br />
          <br />
          Sink three balls in a row to activate a <strong>Triple Shot Perk</strong>, which can earn you{' '}
          <strong>bonus points</strong>, <strong>extra multipliers</strong>, or even an{' '}
          <strong>additional cue ball</strong>. Clear the table to score a <strong>Table Clear bonus</strong> and rack
          up extra rewards. With identical setups for every player, this <strong>free pool game</strong> is all about
          skill, timing, and high-scoring strategy in every fast-paced match.
        </>
      ),
      image: Detail1,
    },
    {
      title: 'Fair Matches, Custom Cues, and Real Prizes Await',
      description: (
        <>
          Once you’ve sharpened your aim and mastered the basics, it’s time to raise the stakes.{' '}
          <strong>8 Ball Strike</strong> takes you from casual play to high-intensity,{' '}
          <strong>skill-based games</strong> where every shot matters—and every player plays under the same rules. Each
          match features identical <strong>8 ball setups</strong> and time limits, ensuring a level playing field where
          true skill shines!
          <br />
          <br />
          Challenge global opponents in <strong>multiplayer tournaments</strong>, unlock a wide selection of custom{' '}
          <strong>pool cues</strong>, and dive into exciting limited-time events like <strong>Cash Catch</strong> and{' '}
          <strong>Billiard Blast</strong>. This is more than a <strong>free pool game</strong>—it’s a test of focus,
          strategy, and style, with real rewards on the line.
        </>
      ),
      image: Detail2,
    },
    {
      title: 'Secure Payouts with Trusted Payment Methods',
      description: (
        <>
          Winning in <strong>8 Ball Strike</strong> is fun—and earning real awards is even better! Enjoy{' '}
          <strong>secure withdrawals</strong> via <strong>PayPal</strong>, and make deposits using{' '}
          <strong>Venmo</strong>, <strong>PayPal</strong>, <strong>Apple Pay</strong>, <strong>Visa</strong>,{' '}
          <strong>Mastercard</strong>, <strong>Amex</strong>, or <strong>Discover</strong>.
          <br />
          <br />
          Transactions are protected, so you can relax and enjoy this <strong>free pool game</strong> knowing your
          earnings are in good hands. It’s all part of the welcoming experience—easy to start, safe to play, and
          rewarding to win.
        </>
      ),
      image: Detail3,
    },
    {
      title: 'Join the Fun and Explore More from Avia',
      description: (
        <>
          <strong>8 Ball Strike</strong> is an <strong>8 ball pool game</strong> that anyone can jump into—no experience
          needed! With quick, action-packed rounds and skill-based challenges, it’s perfect for short breaks or winding
          down after a long day.
          <br />
          <br />
          Whether you&#39;re playing for fun or aiming for real rewards, there&#39;s always a new way to compete and
          improve.
          <br />
          <br />
          Loving the thrill of <strong>8 Ball Strike: Win Real Cash</strong>? Keep the momentum going with{' '}
          <strong>8 Ball Strike: Cash Pool</strong> for classic 1v1 real-time matches! Then, check out{' '}
          <GamesLink strong>more games</GamesLink>! Other gamer favorites like <BingoClashLink strong /> and{' '}
          <SolitaireClashLink strong />, where you can experience fast-paced gameplay, win real prizes, and have fun
          anytime!
        </>
      ),
    },
  ],
  footer: {
    image: Footer,
  },
}
